import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

import { ERROR_MESSAGES } from "constants/validation";

/**
 * Product Schema
 * Represents a product that can be promoted by affiliates
 * Base schema is loose to allow loading legacy data.
 */
export const ProductSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    id: Yup.string().nullable(),
    sku: Yup.string().nullable(),
    name: Yup.string().nullable(),
    price: Yup.number().nullable(),
    img: Yup.string().nullable(),
    imgThumbnail: Yup.string().nullable(),
    pricePromotion: Yup.number().nullable(),
    pricePromotionPercent: Yup.number().nullable(),
    inFlashSale: Yup.boolean().default(false),
    flashSaleStockLimit: Yup.date().nullable(),
    stock: Yup.number().nullable(),
    tag: Yup.string().nullable(),
    tagThai: Yup.string().nullable(),
    packsize: Yup.string().nullable(),
    maximumPerOrder: Yup.number().nullable(),
    productCode: Yup.string().nullable(),
    isActive: Yup.boolean().default(false),
    isRecommended: Yup.boolean().default(false),
    recommendType: Yup.string().nullable(),

    // Timestamps
    updatedAt: Yup.date().nullable(),
    createdAt: Yup.date().nullable(),
  });

/**
 * Product Validation Schema
 * Strict rules applied only during form submission.
 */
export const ProductValidationSchema = ProductSchema.clone().shape({
  sku: Yup.string().required(ERROR_MESSAGES.SKU_REQUIRED),
  name: Yup.string().required(ERROR_MESSAGES.NAME_REQUIRED),
  price: Yup.number()
    .required(ERROR_MESSAGES.PRICE_REQUIRED)
    .min(0, ERROR_MESSAGES.MIN_VALUE(0)),
});
